import { render, staticRenderFns } from "./selectPSentences.vue?vue&type=template&id=65bf5ff3"
import script from "./selectPSentences.vue?vue&type=script&lang=js"
export * from "./selectPSentences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports